(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function isMobileHeaderSearch(component) {
    return !component.mobileMenu && mobileQuery.matches && !!component.closest('.header__mobile');
  }

  function findOwningComponent(node) {
    if (!node) return null;

    return [...document.querySelectorAll('header-search-popdown')].find((component) => {
      return component.popdown === node || component.popdown?.contains(node);
    });
  }

  function getUnderlay(component) {
    if (component._underlay?.isConnected) return component._underlay;

    component._underlay = component.querySelector('[data-popdown-underlay]');
    return component._underlay;
  }

  function setMobileSearchBodyState(active) {
    document.body.classList.toggle('mobile-search-open', active);
  }

  function applyTeleportedStyles(popdown, underlay) {
    popdown.style.setProperty('position', 'fixed', 'important');
    popdown.style.setProperty('top', '0', 'important');
    popdown.style.setProperty('left', '0', 'important');
    popdown.style.setProperty('right', '0', 'important');
    popdown.style.setProperty('width', '100%', 'important');
    popdown.style.setProperty('max-width', 'none', 'important');
    popdown.style.setProperty('margin-top', '0', 'important');
    popdown.style.setProperty('transform', 'none', 'important');
    popdown.style.setProperty('opacity', '1', 'important');
    popdown.style.setProperty('visibility', 'visible', 'important');

    if (underlay) {
      underlay.style.setProperty('position', 'fixed', 'important');
      underlay.style.setProperty('top', '0', 'important');
      underlay.style.setProperty('left', '0', 'important');
      underlay.style.setProperty('right', '0', 'important');
      underlay.style.setProperty('bottom', '0', 'important');
      underlay.style.setProperty('width', 'auto', 'important');
      underlay.style.setProperty('height', 'auto', 'important');
    }
  }

  function repositionPopdown(component, active) {
    if (!isMobileHeaderSearch(component)) return;

    const popdown = component.popdown;
    const underlay = getUnderlay(component);
    if (!popdown) return;

    if (active) {
      if (!component._popdownPlaceholder) {
        component._popdownPlaceholder = document.createComment('search-popdown');
        popdown.parentNode.insertBefore(component._popdownPlaceholder, popdown);
      }

      if (!component._underlayPlaceholder && underlay) {
        component._underlayPlaceholder = document.createComment('search-underlay');
        underlay.parentNode.insertBefore(component._underlayPlaceholder, underlay);
      }

      document.body.appendChild(popdown);
      if (underlay) document.body.appendChild(underlay);

      popdown.classList.add('search-popdown--teleported', 'is-active');
      if (underlay) {
        underlay.classList.add('search-popdown__underlay--teleported', 'is-active');
      }

      setMobileSearchBodyState(true);
      applyTeleportedStyles(popdown, underlay);

      return;
    }

    popdown.classList.remove('search-popdown--teleported', 'is-active');
    popdown.style.cssText = '';

    if (underlay) {
      underlay.classList.remove('search-popdown__underlay--teleported', 'is-active');
      underlay.style.cssText = '';
    }

    if (component._popdownPlaceholder?.parentNode) {
      component._popdownPlaceholder.parentNode.insertBefore(popdown, component._popdownPlaceholder);
      component._popdownPlaceholder.remove();
      component._popdownPlaceholder = null;
    }

    if (component._underlayPlaceholder?.parentNode && underlay) {
      component._underlayPlaceholder.parentNode.insertBefore(underlay, component._underlayPlaceholder);
      component._underlayPlaceholder.remove();
      component._underlayPlaceholder = null;
    }

    const mobileSearchOpen = [...document.querySelectorAll('.header__mobile header-search-popdown.is-open')].some(
      (item) => isMobileHeaderSearch(item)
    );
    setMobileSearchBodyState(mobileSearchOpen);
  }

  function scheduleTeleportedStyles(component) {
    if (!isMobileHeaderSearch(component)) return;

    const popdown = component.popdown;
    const underlay = getUnderlay(component);
    if (!popdown?.classList.contains('search-popdown--teleported')) return;

    applyTeleportedStyles(popdown, underlay);

    requestAnimationFrame(() => {
      if (!component.classList.contains('is-open')) return;
      applyTeleportedStyles(popdown, underlay);
    });
  }

  function bindCloseHandler(component) {
    if (!component.popdownClose || component._closeHandlerBound) return;

    component._closeHandlerBound = true;
    component.popdownClose.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      component.close();
    });
  }

  function patchSearchPopdown() {
    const Proto = customElements.get('header-search-popdown')?.prototype;
    if (!Proto || Proto._headerPopdownPatched) return;

    Proto._headerPopdownPatched = true;

    const open = Proto.open;
    const close = Proto.close;
    const connectedCallback = Proto.connectedCallback;
    const detailsToggleCallback = Proto.detailsToggleCallback;
    const popdownTransitionCallback = Proto.popdownTransitionCallback;

    Proto.connectedCallback = function () {
      connectedCallback.call(this);
      bindCloseHandler(this);
    };

    document.addEventListener(
      'click',
      (event) => {
        const closeBtn = event.target.closest('[data-popdown-close]');
        if (!closeBtn) return;

        const component = findOwningComponent(closeBtn.closest('[data-popdown]'));
        if (!component) return;

        event.preventDefault();
        event.stopPropagation();
        component.close();
      },
      true
    );

    Proto.detailsToggleCallback = function (event) {
      if (event.target.hasAttribute('open')) {
        repositionPopdown(this, true);
        scheduleTeleportedStyles(this);
      }

      detailsToggleCallback.call(this, event);
    };

    Proto.open = function () {
      bindCloseHandler(this);
      repositionPopdown(this, true);
      scheduleTeleportedStyles(this);
      this.onBodyClickEvent = this.onBodyClick.bind(this);
      open.call(this);
    };

    Proto.close = function () {
      close.call(this);
      repositionPopdown(this, false);

      if (this.popdownContainer?.hasAttribute('open')) {
        this.popdownContainer.removeAttribute('open');
      }

      this.a11y?.removeTrapFocus();
    };

    Proto.onBodyClick = function (event) {
      if (event.target.closest('[data-popdown-close]')) {
        this.close();
        return;
      }

      const inPopdown = this.popdown?.contains(event.target);
      const inComponent = this.contains(event.target);
      const onUnderlay = event.target.hasAttribute('data-popdown-underlay');

      if ((!inComponent && !inPopdown) || onUnderlay) {
        this.close();
      }
    };

    Proto.popdownTransitionCallback = function (event) {
      if (event.target !== this.popdown || event.propertyName !== 'opacity') return;

      if (!this.classList.contains('is-open')) {
        this.popdownContainer.removeAttribute('open');
        this.a11y.removeTrapFocus();
        repositionPopdown(this, false);
      } else {
        repositionPopdown(this, true);
        scheduleTeleportedStyles(this);
        this.a11y.trapFocus(this.popdown, {
          elementToFocus: this.popdown.querySelector('input:not([type="hidden"])'),
        });
      }
    };

    document.querySelectorAll('header-search-popdown').forEach((component) => {
      bindCloseHandler(component);

      if (!component.classList.contains('is-open')) {
        repositionPopdown(component, false);
      } else {
        getUnderlay(component);
      }
    });
  }

  if (customElements.get('header-search-popdown')) {
    patchSearchPopdown();
  } else {
    customElements.whenDefined('header-search-popdown').then(patchSearchPopdown);
  }
})();
